import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useQuery } from 'react-apollo';
import {
  Modal, ModalBody, UncontrolledButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem,
} from 'reactstrap';
import ReactImageFallback from 'react-image-fallback';
import AssocoatedOffers from '../comps/AssociatedOffers';
import { FALLBACK_ICON, capitalizeEveryWord, staticConstants } from '../../utils';
import { GET_ASSOCIATED_DATA_QUERY } from '../../graphql-client/queries';

function ManagerDetail(props) {
  const {
    isOpen, onClose, item, openEditProfileForm, toggleDeactivateModal, userId,
  } = props;

  const [modal, setModal] = useState(isOpen);
  const toggle = () => {
    setModal(!modal);
    onClose();
  };

  const hideModal = () => {
    toggle();
    props.onClose();
  };

  const {
    data: apiAssociatedData,
  } = useQuery(
    GET_ASSOCIATED_DATA_QUERY, {
      variables: { managerId: userId },
    },
  );

  return (
    <Modal isOpen={modal} className="modal-manager-detail modal-dialog-centered">
      <ModalBody>
        <span
          onClick={hideModal}
          className="icon icon-cross"
        />
        <div className="modal-manager-detail-bio">
          <span>
            <ReactImageFallback
              src={item.img}
              fallbackImage={FALLBACK_ICON}
              className="image-cover"
              alt="User"
            />
          </span>
          <div className="modal-manager-detail-content">
            <p>
              Member since
              {' '}
              {item.registerDate || ''}
            </p>
            <h4>
              {' '}
              {capitalizeEveryWord(`${item.managerFirstName} ${item.managerLastName}`) || ''}
              {' '}
            </h4>
            <em>
              <span>Company:</span>
              {capitalizeEveryWord(item.companyName) || ''}
            </em>
            <UncontrolledButtonDropdown className="action-dropdown-toggle">
              <DropdownToggle>
                <div className="modal-toggle" />
              </DropdownToggle>
              <DropdownMenu right className="dropdown-theme action-dropdown">
                <DropdownItem onClick={() => {
                  hideModal();
                  toggleDeactivateModal(item);
                }}
                >
                  {item.status === staticConstants.STATUS_TYPE.DEACTIVATED
                    ? 'Activate Account' : 'Deactivate Account'}
                </DropdownItem>
                <DropdownItem onClick={() => {
                  hideModal();
                  openEditProfileForm(item);
                }}
                >
                  Edit Label Info
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledButtonDropdown>
          </div>
        </div>
        <div className="modal-manager-detail-info">
          <p>
            <span className="ico icon-phone" />
            {item.contactNumber || ''}
          </p>
          <p>
            <span className="ico icon-email" />
            {item.email || ''}
          </p>
        </div>
        {
            apiAssociatedData && apiAssociatedData.associatedOffer

            && (
            <AssocoatedOffers
              associatedData={apiAssociatedData.associatedOffer}
              isManagerDetail
              revenue={item.totalRevenue}
              totalOffer={item.totalOffer}
            />
            )
          }
      </ModalBody>
    </Modal>
  );
}

ManagerDetail.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  item: PropTypes.object.isRequired,
  openEditProfileForm: PropTypes.func.isRequired,
  toggleDeactivateModal: PropTypes.func.isRequired,
  userId: PropTypes.string.isRequired,
};

export default ManagerDetail;
